import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { TrustMarquee } from "@/components/Marquees";
import { TopHeader } from "@/components/TopHeader";
import { Hero } from "@/components/Hero";
import { LogoMarquee } from "@/components/Marquees";
import { BrandStatement } from "@/components/BrandStatement";
import { Services } from "@/components/Services";
import { PixelGrass } from "@/components/PixelGrass";
import { FeaturedWork } from "@/components/FeaturedWork";
import { Numbers } from "@/components/Numbers";
import { WhyNagel } from "@/components/WhyNagel";
import { OurStory } from "@/components/OurStory";
import { Testimonials } from "@/components/Testimonials";
import { ServiceArea } from "@/components/ServiceArea";
import { FAQ } from "@/components/FAQ";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { FloatingNav } from "@/components/FloatingNav";
import { AIChat } from "@/components/AIChat";
import { CallButton } from "@/components/CallButton";
import { VoiceGreeting } from "@/components/VoiceGreeting";
import { InquiryModal } from "@/components/InquiryModal";

function App() {
  const [inquiry, setInquiry] = useState({ open: false, service: "" });

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let lenis = null;
    let raf = null;
    if (!reduced) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      window.__lenis = lenis;
      const loop = (t) => {
        lenis.raf(t);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    }
    const onInquiry = (e) => setInquiry({ open: true, service: e.detail?.service || "" });
    window.addEventListener("nagel:inquiry", onInquiry);
    return () => {
      window.removeEventListener("nagel:inquiry", onInquiry);
      if (raf) cancelAnimationFrame(raf);
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const closeInquiry = useCallback(() => setInquiry((i) => ({ ...i, open: false })), []);

  return (
    <div className="App bg-cream text-charcoal font-body overflow-x-clip">
      <TrustMarquee />
      <div className="h-2.5 bg-cream" aria-hidden="true" />
      <TopHeader />
      <main>
        <Hero />
        <LogoMarquee />
        <BrandStatement />
        <Services />
        <PixelGrass />
        <FeaturedWork />
        <Numbers />
        <WhyNagel />
        <OurStory />
        <Testimonials />
        <ServiceArea />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingNav />
      <AIChat />
      <CallButton />
      <VoiceGreeting />
      <InquiryModal open={inquiry.open} service={inquiry.service} onClose={closeInquiry} />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
